export const AWAITING = {
    THANKS_FOR_COMPLETING: "Thanks for completing your registration.",
    YOUR_REQUEST: "Your request has now been placed with ",
    YOU_EDIT: "You can edit your registration until you are blessed with a seat.",
    MAHATRIA: "Mahatria.",
    OFFER_SEAT:"You were offered a sacred seat in (HDB/MSD) by Mahatria.",
    BLESS_HOLD: "Based on your request, your seat is on HOLD.",

}
export const REGISTRAITON_SUCCESS = {
    ACKNOWLEDGE: "We acknowledge your payment towards ",
}

export const REGISTRAITON_FORM ={
    RESET_PREFERENCE:"Reset preference"
}